import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AppAdministratorsQuery from '@/plugins/graphql/queries/app-administrators.gql';
import AppAdminDeleteMutation from '@/plugins/graphql/mutations/app-admin-delete.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import { successfulDestroy, confirmation } from '@/helpers/mixins/LocalizationHelper';
import LinkButton from '@/components/link_button/Index.vue';
import ActionButton from '@/components/action_button/Index.vue';
import CachedAppAdministratorsMixin from '@/helpers/vue_mixins/CachedAppAdministratorsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { Mutation } from 'vuex-class';
import Avatar from '@/components/avatar/Index.vue';
let SettingsMembersList = class SettingsMembersList extends mixins(FormMixin, CachedAppAdministratorsMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.fetchAppAdmin = { edges: [] };
        this.modelName = 'Administrator';
        this.confirmationMessage = confirmation(this.modelName);
        this.headerProperties = {
            align: 'left',
            sortable: false,
        };
        // header used in datatable
        this.headers = [
            { text: 'NAME', ...this.headerProperties },
            { text: 'EMAIL', ...this.headerProperties },
            { text: 'ROLE', ...this.headerProperties },
            { text: 'ACTIONS', align: 'center', sortable: false },
        ];
    }
    setSelectedAdminUuid(uuid) {
        this.selectedAdministratorUuid = uuid;
        this.showConfirmationDialog();
    }
    removeAdminCallback() {
        const message = successfulDestroy(this.modelName);
        this.toggleAlert(message, AlertType.success);
    }
    membersCount() {
        const admins = this.fetchAppAdmin;
        if (!!admins && !!admins.edges) {
            return admins.edges.length;
        }
    }
    async removeAdmin() {
        this.isRequestOnProcess = true;
        await this.$apollo
            .mutate({
            mutation: AppAdminDeleteMutation,
            variables: {
                input: {
                    userUuid: this.selectedAdministratorUuid,
                    appUuid: this.appUUID,
                },
            },
            update: (store) => {
                const data = this.fetchCachedAppAdmin(store);
                if (data) {
                    const { edges } = data.fetchAppAdmin;
                    data.fetchAppAdmin.edges = edges.filter((v) => {
                        return v.node.uuid !== this.selectedAdministratorUuid;
                    });
                }
                store.writeQuery({ query: AppAdministratorsQuery, data });
            },
        })
            .then(() => {
            this.removeAdminCallback();
        })
            .catch((error) => {
            this.formCallbackError(error.message);
        });
        this.hideConfirmationDialog();
        this.isRequestOnProcess = false;
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], SettingsMembersList.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], SettingsMembersList.prototype, "hideConfirmationDialog", void 0);
SettingsMembersList = __decorate([
    Component({
        components: {
            ActionButton,
            ConfirmationDialog,
            LinkButton,
            Avatar,
        },
        apollo: {
            fetchAppAdmin: {
                query: AppAdministratorsQuery,
                variables() {
                    return {
                        appUUID: this.appUUID,
                    };
                },
            },
        },
    })
], SettingsMembersList);
export default SettingsMembersList;
